import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { AllCommunityModule, ModuleRegistry as AgChartsModuleRegistry } from 'ag-charts-community';
import { AllEnterpriseModule, LicenseManager, ModuleRegistry, provideGlobalGridOptions } from "ag-grid-enterprise";
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import './polyfills';

ModuleRegistry.registerModules([AllEnterpriseModule]);
AgChartsModuleRegistry.registerModules(AllCommunityModule);
provideGlobalGridOptions({ theme: 'legacy' });

LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-116408}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{S&P_Global_Inc.}_is_granted_a_{Multiple_Applications}_Developer_License_for_{10}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{31_March_2027}____[v3]_[01]_MTgwNjQ0NzYwMDAwMA==187816fd162534886813f178a3af11e8");
if (environment.production) {
  enableProdMode();
  if (window) {
    window.console.log = function () { };
    window.console.warn = function () { }; //HACK: WEB-3231, Ading back as WEB-3236 coudnt be completed in the sprint.
  }
}

platformBrowser().bootstrapModule(AppModule);
